import React, { useEffect, useState } from "react";
import Input from "../FormInputs";
import { ReactComponent as DownArrow } from "../../../Assets/Icons/greyDownArrow.svg";
import Selector from "../Selector";
import { Slider } from "antd";
import RadioSelection from "../RadioSelection";
import InputTextArea from "../InputTextArea";
import UploadDocument from "./UploadDocument";
import UploadDocuments from "./UploadDocuments";
import { useFormik } from "formik";
import PrimaryButton from "../PrimaryButton";
import GreyButton from "../GreyButton";
import { offerCreationSchema } from "../../../utils/validationSchemas";
import { useDispatch, useSelector } from "react-redux";
import { createOffer } from "../../../services/offerService";
import { uploadFile } from "../../../utils/s3";
import toast from "../../../utils/toast";
import CSVUpload from "./CSVUpload";
// import { ReactComponent as DollarIcon } from "../../../Assets/Icons/dollar.svg";
// import CancelPopup from "../CancelPopup";

const OfferCreation = ({
  stepIndex,
  setStepIndex,
  handlePrevious,
  setPayloadData,
  editOfferData,
  isEdit,
  selectedMerchant,
}) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.offerReducer?.loading);
  const offerData = useSelector((state) => state?.offerReducer?.createdOffer);
  const [thumbnailImageUrl, setThumbnailImageUrl] = useState(null);
  const [previewImagesUrl, setPreviewImagesUrl] = useState([]);
  const [activeUploads, setActiveUploads] = useState(0); // aggregate uploading counter
  const isUploading = activeUploads > 0;

  //To be reviewed
  const [logoFileImage, setLogoFileImage] = useState(null);
  const [logoFileImage1, setLogoFileImage1] = useState(null);
  const [logoFileImage2, setLogoFileImage2] = useState(null);
  const [logoFileImage3, setLogoFileImage3] = useState(null);
  const [logoFileImage4, setLogoFileImage4] = useState(null);
  const [fileloading, setFileLoading] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [fileData, setFileData] = useState();

  const validateFile = (data) => {
    var idxDot = data.lastIndexOf(".") + 1;
    var extFile = data.substr(idxDot, data.length).toLowerCase();
    if (extFile === "csv" || extFile === "xlsx" || extFile === "xls") {
      return true;
    } else {
      return false;
    }
  };
  const validateOfferCodeFormat = (code) => {
    const codePattern = /^[A-Z0-9]{7}$/;
    return codePattern.test(code);
  };
  const handleAcceptedFiles = async (event) => {
    const file = event.target.files[0];
    console.log("file", file);
    if (validateFile(file?.name)) {
      setFileLoading(true);

      // Read the CSV file
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        const lines = text.split("\n");
        // Remove header row and empty lines, then trim each code
        const codes = lines
          .slice(1) // Skip header row
          .filter((line) => line.trim() !== "") // Remove empty lines
          .map((line) => line.trim()); // Trim whitespace

        if (codes.length > 0) {
          // Validate each code format
          const invalidCodes = codes.filter(
            (code) => !validateOfferCodeFormat(code)
          );

          if (invalidCodes.length > 0) {
            toast.error(
              `Invalid code format found: ${invalidCodes.join(
                ", "
              )}. Codes must be 7 characters (letters and numbers only).`
            );
            handleRejectedFiles(file);
            setFileLoading(false);
            return;
          }
          setFieldValue("offerCodes", codes);
          setFieldValue("document", file?.name);
        } else {
          toast.error("No valid offer codes found in the CSV file");
          handleRejectedFiles(file);
        }
        setFileLoading(false);
      };
      reader.onerror = () => {
        toast.error("Error reading the CSV file");
        handleRejectedFiles(file);
        setFileLoading(false);
      };
      reader.readAsText(file);
    } else {
      toast.error(`Only .csv, .xls, and .xlsx files are allowed!`);
      handleRejectedFiles(file);
    }
  };

  const handleRejectedFiles = (files) => {
    const file = files[0];
    setFileData(null);
    setFieldValue("document", null);
    files[0]?.errors?.forEach((error) => {
      toast.error(error.message);
    });
  };

  const handleClear = () => {
    setFileUrl(null);
    setFileData(null);
    setFieldValue("document", "");
    setFieldValue("offerCodes", []);
  };

  const fillUpForm = (data) => {
    setFieldValue("title", data?.title !== null ? data?.title : "");
    setFieldValue("offerType", data?.offerType || "INSTORE_SWOODLE_OFFER");
    setFieldValue("onlineOption", data?.onlineOption || "ONLINE");
    setFieldValue("websiteURL", data?.websiteURL || null);
    setFieldValue("offerCodes", data?.offerCodes || []);
    switch (data?.offerDiscountType) {
      case "FREE_OFFER":
        setFieldValue("offerDiscountType", "FREE_OFFER");
        break;
      case "DISCOUNTED_PERCENT":
        setFieldValue("offerDiscountType", "DISCOUNTED_PERCENT");
        break;
      case "FIXED_DOLLAR":
        setFieldValue("offerDiscountType", "FIXED_DOLLAR");
        break;
      case "BUY_ONE_GET_ONE_FREE":
        setFieldValue("offerDiscountType", "BUY_ONE_GET_ONE_FREE");
        break;
      case "BUNDLE_OFFER":
        setFieldValue("offerDiscountType", "BUNDLE_OFFER");
        break;
      default:
        setFieldValue("offerDiscountType", "");
    }
    setRangeValue(data?.discountRange !== null ? data?.discountRange : 25);
    setFieldValue(
      "discountRange",
      data?.discountRange !== 0 ? data?.discountRange : 25
    );
    setFieldValue(
      "fixedDollarAmount",
      data?.fixedDollarAmount !== 0 ? data?.fixedDollarAmount : 0
    );
    setFieldValue(
      "description",
      data?.description !== null ? data?.description : ""
    );
    setFieldValue(
      "thumbnailImage",
      data?.thumbnailImage !== null ? data?.thumbnailImage : null
    );
    if (data?.thumbnailImage) {
      setThumbnailImageUrl(process.env.REACT_APP_S3_URL + data?.thumbnailImage);
      setLogoFileImage(process.env.REACT_APP_S3_URL + data?.thumbnailImage);
    } else {
      setThumbnailImageUrl(null);
      setLogoFileImage(null);
    }

    setFieldValue("previewImages", data?.previewImages || []);
    setPreviewImagesUrl(data?.previewImages || []);
    if (data?.previewImages?.length > 0) {
      data.previewImages.forEach((p, index) => {
        const imageUrl = process.env.REACT_APP_S3_URL + p;
        if (!p.includes(`${offerData?._id}-previewImg`)) {
          switch (index) {
            case 0:
              setLogoFileImage1(imageUrl);
              break;
            case 1:
              setLogoFileImage2(imageUrl);
              break;
            case 2:
              setLogoFileImage3(imageUrl);
              break;
            case 3:
              setLogoFileImage4(imageUrl);
              break;
          }
        } else {
          if (p.includes(`${offerData?._id}-previewImg1`)) {
            setLogoFileImage1(imageUrl);
          } else if (p.includes(`${offerData?._id}-previewImg2`)) {
            setLogoFileImage2(imageUrl);
          } else if (p.includes(`${offerData?._id}-previewImg3`)) {
            setLogoFileImage3(imageUrl);
          } else if (p.includes(`${offerData?._id}-previewImg4`)) {
            setLogoFileImage4(imageUrl);
          }
        }
      });
    }
  };

  useEffect(() => {
    if (editOfferData !== null && isEdit === true) {
      fillUpForm(editOfferData);
    } else if (offerData?.thumbnailImage) {
      fillUpForm(offerData);
    }
  }, [offerData, editOfferData]);

  const initialValues = {
    title: "",
    offerType: "INSTORE_SWOODLE_OFFER",
    offerDiscountType: "",
    onlineOption: "ONLINE",
    offerCodes: [],
    fixedDollarAmount: null,
    description: "",
    discountRange: 25,
    thumbnailImage: null,
    previewImages: [],
    document: "",
    websiteURL: null,
  };

  const handleNextStep = async () => {
    console.log("handleNextStep called");
    console.log("Current form values:", { offerCodes, onlineOption, offerType });

    const processedCodes = processOfferCodes();
    console.log("Processed codes:", processedCodes);

    const currentPayload = {
      id: offerData?._id,
      merchantId: selectedMerchant?._id,
      title: title,
      offerType: offerType,
      offerDiscountType: offerDiscountType,
      onlineOption: onlineOption,
      discountRange: discountRange,
      fixedDollarAmount: fixedDollarAmount,
      offerCodes: processedCodes,
      thumbnailImage: thumbnailImage,
      previewImages: previewImagesUrl,
      ...(description?.trim()
        ? { description: description.trim() }
        : {}),
      websiteURL: websiteURL,
      isCreated: false,
    };

    console.log("Sending payload to createOffer:", currentPayload);

    const createPromise = await dispatch(
      createOffer({ ...currentPayload, offerId: offerData?._id })
    )?.unwrap();
    if (createPromise?.success === true) {
      console.log("createOffer successful, moving to next step");
      setStepIndex(stepIndex + 1);
    } else {
      console.log("createOffer failed:", createPromise);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema: offerCreationSchema,

    onSubmit: async (values) => {
      console.log("Form onSubmit called with values:", values);
      console.log("Form errors:", formik.errors);
      console.log("Form touched:", formik.touched);
      await handleNextStep();
    },
  });
  const attemptNext = async () => {
    const validationErrors = await formik.validateForm();
    if (!formik.values.offerType) {
      formik.setTouched({ ...formik.touched, offerType: true });
      formik.setFieldError("offerType", "Offer Type Selection is required");
    }
    if (Object.keys(validationErrors || {}).length > 0 || !formik.values.offerType) {
      scrollToFirstError({ ...validationErrors, ...(formik.values.offerType ? {} : { offerType: "Offer Type Selection is required" }) });
      return;
    }
    handleSubmit();
  };

  const {
    title,
    offerType,
    onlineOption,
    offerDiscountType,
    discountRange,
    fixedDollarAmount,
    description,
    offerCodes,
    websiteURL,
    document,
    thumbnailImage,
    previewImages,
  } = formik.values;

  const {
    handleChange,
    handleBlur,
    errors,
    touched,
    setFieldValue,
    handleSubmit,
    // setValues,
  } = formik;

  const scrollToFirstError = (formErrors) => {
    const priority = [
      "title",
      "offerType",
      "offerDiscountType",
      "description",
      "discountRange",
      "fixedDollarAmount",
      "thumbnailImage",
      "previewImages",
      "websiteURL",
      "offerCodes",
    ];
    let targetField = priority.find(
      (key) => formErrors && Object.prototype.hasOwnProperty.call(formErrors, key)
    );
    if (!targetField) {
      const keys = Object.keys(formErrors || {});
      targetField = keys.length ? keys[0] : null;
    }
    if (!targetField) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const doc = window.document;
    let el =
      doc.querySelector(`[data-field="${targetField}"]`) ||
      doc.querySelector(`[name="${targetField}"]`) ||
      doc.querySelector(`input[name="${targetField}"]`) ||
      doc.querySelector(`textarea[name="${targetField}"]`) ||
      doc.querySelector(`select[name="${targetField}"]`);
    if (el && typeof el.scrollIntoView === "function") {
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      if (typeof el.focus === "function") {
        try {
          el.focus();
        } catch (_) { }
      }
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  // validation will be applied inline on Next click for this step

  const handleOfferCodesChange = (e) => {
    const value = e.target.value;
    // Store the raw input value, we'll process it on blur or form submission
    setFieldValue("offerCodes", value);
  };

  const processOfferCodes = () => {
    if (typeof offerCodes === "string") {
      const codesArray = offerCodes
        .split(",")
        .map((code) => code.trim())
        .filter((code) => code !== "");
      setFieldValue("offerCodes", codesArray);
      return codesArray;
    }
    return offerCodes;
  };

  const handleOfferCodesBlur = (e) => {
    processOfferCodes(); // Reuse the same processing logic
    handleBlur(e);
  };

  const payload = {
    id: offerData?._id,
    merchantId: selectedMerchant?._id,
    title: title,
    offerType: offerType,
    offerDiscountType: offerDiscountType,
    // offerDiscountType: offerDiscountType === "Free Offer"
    //   ? "FREE_OFFER"
    //   : offerDiscountType === "Discounted Offer"
    //     ? "DISCOUNTED_PERCENT"
    //     : offerDiscountType === "Fixed Dollar Discount"
    //       ? "FIXED_DOLLAR"
    //       : offerDiscountType === "Buy One Get One Free Offer"
    //         ? "BUY_ONE_GET_ONE_FREE"
    //         : offerDiscountType === "Bundle Offer"
    //           ? "BUNDLE_OFFER"
    //           : "",
    onlineOption: onlineOption,
    discountRange: discountRange,
    fixedDollarAmount: fixedDollarAmount,
    offerCodes: offerCodes,
    thumbnailImage: thumbnailImage,
    previewImages: previewImagesUrl,
    ...(description?.trim()
      ? { description: description.trim() }
      : {}),
    websiteURL: websiteURL,
    isCreated: false,
  };

  // console.log("Payload Data ==>>", previewImagesUrl);

  useEffect(() => {
    setPayloadData(payload);
    // console.log("Preview Images ==>>", formik.values.previewImages)
  }, [
    offerData?._id,
    title,
    offerType,
    offerDiscountType,
    discountRange,
    description,
    thumbnailImage,
    previewImages,
    offerCodes, // Add offerCodes to dependencies
    onlineOption, // Add onlineOption to dependencies
  ]);

  const offerTypeOptions = [
    { label: "Instore Swoodle Offer", value: "INSTORE_SWOODLE_OFFER" },
    { label: "Online Offer", value: "ONLINE_OFFER" },
  ];

  const offerDiscountTypeOptions = [
    { label: "Free Offer", value: "FREE_OFFER" },
    { label: "Discounted Offer", value: "DISCOUNTED_PERCENT" },
    { label: "Fixed Dollar Discount", value: "FIXED_DOLLAR" },
    {
      label: "Buy One Get One Free Offer",
      value: "BUY_ONE_GET_ONE_FREE",
    },
    { label: "Bundle Offer", value: "BUNDLE_OFFER" },
  ];

  const handleTypeChange = (e) => {
    setFieldValue("offerType", e);
    if (e === "INSTORE_SWOODLE_OFFER" && stepIndex > 5) {
      setStepIndex(6);
    }
  };

  const handleDiscountTypeChange = (e) => {
    setFieldValue("offerDiscountType", e);
  };

  // const radioOptions = ["Featured Offers", "Hot Offers"];
  const radioOnlineOptions = [
    {
      title: "ONLINE",
      value: "ONLINE",
      content:
        "To claim this offer, users will be redirected to the merchant's website.",
    },
    {
      title: "Online with Code",
      value: "ONLINE_WITH_CODE",
      content:
        "The user can copy the code and use it on the merchant's website.",
    },
  ];
  const [rangeValue, setRangeValue] = useState(25);
  const [isSliderDragging, setIsSliderDragging] = useState(false);

  const handleRangeChange = (value) => {
    setIsSliderDragging(true);
    const parsedValue = Math.min(Math.max(0, Number(value) || 0), 100);
    setRangeValue(parsedValue);
    setFieldValue("discountRange", parsedValue);
  };

  const handleRangeAfterChange = (value) => {
    setIsSliderDragging(false);
  };

  useEffect(() => {
    if (offerDiscountType === "DISCOUNTED_PERCENT") {
      // Initialize the range values when discount type is selected
      const initialRange = discountRange || 25;
      setRangeValue(initialRange);
      setFieldValue("discountRange", initialRange);
    }
  }, [offerDiscountType]);

  const isNextButtonBusy = Boolean(loading) || isUploading;
  const nextButtonLabel = isNextButtonBusy ? (
    <span className="flex items-center justify-center gap-2">
      <span className="offer-btn-spinner" />
      <span>{isUploading ? "Uploading..." : "Processing..."}</span>
    </span>
  ) : (
    "Next"
  );

  return (
    <div className="w-full flex flex-col items-center justify-center mt-20">
      <div className="sm:w-[100%] md:w-[80%] lg:w-[70%] xl:w-[55%] offerform">
        <p className="font-poppins font-[500] sm:text-[12px] md:text-[14px] lg:text-[16px] text-[#303030]">
          Let's make your offer stand out!
        </p>
        <p className="font-poppins font-[400] sm:text-[10px] md:text-[12px] text-[#767676]">
          Briefly describe the highlights of offer
        </p>
        {/* 1. Offer Title */}
        <Input
          type="text"
          label="Offer Title"
          labelClassName="font-[500]"
          placeholder="Enter offer title"
          width="100%"
          radius="5px"
          InputDivClass="w-[100%] mt-5"
          name="title"
          value={title}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.title}
          touched={touched.title}
        />
        {/* 2. Offer Description */}
        <div className="mt-5 w-full">
          <div className="flex items-center justify-between mb-[4px]">
            <span className="flex items-baseline gap-1">
              <span className="font-[500] text-[#303030] font-poppins invitationLabels offer-description-label">Offer Description</span>
              <span className="text-[11px] text-[#767676] font-normal leading-[21px]">(Optional)</span>
            </span>
            {description && (
              <span className="text-[#D9D9D9] text-[10px] font-poppins">
                {description?.length || 0}/400
              </span>
            )}
          </div>
          <InputTextArea
            label={null}
            placeholder={"Description"}
            divClassName="relative w-full offer-description-group -mt-4"
            labelClassName=""
            textareaClassName="w-full px-[21px] py-2 rounded-[5px] bg-[#FFFFFF] border border-[#D9D9D9] text-[#303030] lg:text-[14px] sm:text-[12px] font-[400] outline-none resize-none font-poppins overflow-hidden"
            name="description"
            value={description}
            handleBlur={handleBlur}
            error={undefined}
            touched={false}
            setFieldValue={setFieldValue}
            maxCharacters={400}
            showCounter={false}
            baseHeight={45}
          />
        </div>
        {/* 3. Add a Thumbnail */}
        <p className="font-poppins font-[500] sm:text-[12px] md:text-[14px] lg:text-[16px] text-[#303030] mt-8">
          Add a Thumbnail
        </p>
        <p className="font-poppins font-[400] sm:text-[10px] md:text-[12px] text-[#767676] mt-2">
          Select or upload a picture
        </p>
        <UploadDocument
          thumbnail={thumbnailImage}
          name={"thumbnailImage"}
          iconText={"Upload Thumbnail"}
          error={errors?.thumbnailImage}
          touched={touched?.thumbnailImage}
          setFieldValue={setFieldValue}
          parentDivClass={"h-[370px] w-[100%] mt-5"}
          setS3Url={setThumbnailImageUrl}
          logoFileImage={logoFileImage}
          setLogoFileImage={setLogoFileImage}
          autoCompress={true}
          dropzoneMaxSize={10485760}
          onLoadingChange={(flag) => setActiveUploads((prev) => flag ? prev + 1 : Math.max(0, prev - 1))}
        />
        {/* 4. Offer Images */}
        <p className="font-poppins font-[500] sm:text-[12px] md:text-[14px] lg:text-[16px] text-[#303030] mt-10">
          Offer Image
        </p>
        <p className="font-poppins font-[400] sm:text-[10px] md:text-[12px] text-[#767676] mt-2">
          Make your offer stand out with great images, to help your offer
          perform better, add maximum four images
        </p>
        <UploadDocuments
          previewImages={previewImages || []}
          errors={errors || {}}
          touched={touched || {}}
          setFieldValue={setFieldValue}
          s3Urls={previewImagesUrl}
          setS3Urls={setPreviewImagesUrl}
          logoFileImage1={logoFileImage1}
          setLogoFileImage1={setLogoFileImage1}
          logoFileImage2={logoFileImage2}
          setLogoFileImage2={setLogoFileImage2}
          logoFileImage3={logoFileImage3}
          setLogoFileImage3={setLogoFileImage3}
          logoFileImage4={logoFileImage4}
          setLogoFileImage4={setLogoFileImage4}
          offerId={offerData?._id}
          onAnyLoadingChange={(flag) => setActiveUploads((prev) => flag ? prev + 1 : Math.max(0, prev - 1))}
        />
        {/* 5. Offer Type */}
        <Selector
          value={offerType}
          label={"Offer Type"}
          labelClassName="lg:text-[14px] sm:text-[12px] font-[500] text-[#303030] font-poppins leading-[21px] mb-[4px]"
          divClassName="mt-8 w-[100%]"
          selectClassName="w-full rounded-[1px] bg-[#FFFFFF] text-[#303030] lg:text-[16px] sm:text-[10px] font-[400] !font-poppins !focus:outline-none"
          flexClassName="gap-3"
          options={offerTypeOptions}
          suffixIcon={<DownArrow />}
          placeholder={"Select offer type"}
          onChange={handleTypeChange}
          handleBlur={handleBlur}
          error={errors.offerType}
          touched={touched.offerType}
          defaultValue={offerType}
        />

        {/* Conditional fields for Online Offer Type */}
        {offerType === "ONLINE_OFFER" && (
          <>
            <RadioSelection
              withContent={true}
              options={[
                {
                  title: "ONLINE",
                  value: "ONLINE",
                  content:
                    "To claim this offer, users will be redirected to the merchant's website.",
                },
                {
                  title: "Online with Code",
                  value: "ONLINE_WITH_CODE",
                  content:
                    "The user can copy the code and use it on the merchant's website.",
                },
              ]}
              divClassName="mt-8"
              internalDivClass="flex flex-col items-start"
              secondRadioClass="mt-3"
              textClass="lg:text-[14px] sm:text-[12px] font-[400] text-[#303030] ml-4"
              label={""}
              width={"100%"}
              name="onlineOption"
              value={onlineOption}
              defaultValue={onlineOption}
              error={errors.onlineOption}
              touched={touched.onlineOption}
              setFieldValue={setFieldValue}
            />

            {onlineOption === "ONLINE_WITH_CODE" ? (
              <div className="flex flex-col items-start justify-start gap-2">
                {document === "" && (
                  <Input
                    type="text"
                    label=""
                    placeholder="Type Code"
                    width="100%"
                    radius="5px"
                    InputDivClass="w-[100%] mt-5"
                    name="offerCodes"
                    value={
                      Array.isArray(offerCodes)
                        ? offerCodes.join(", ")
                        : offerCodes || ""
                    }
                    handleChange={handleOfferCodesChange}
                    handleBlur={handleOfferCodesBlur}
                    error={errors.offerCodes}
                    touched={touched.offerCodes}
                    info={"Enter multiple codes, separated by commas."}
                  />
                )}
                <div className="w-full flex flex-col justify-center items-center gap-2 mt-2">
                  {document === "" && (
                    <p className="font-poppins font-[400] sm:text-[10px] md:text-[14px] text-[#767676] text-center">
                      Or
                    </p>
                  )}
                  <CSVUpload
                    document={document}
                    handleAcceptedFiles={handleAcceptedFiles}
                    handleClear={handleClear}
                    offerCodesCount={
                      Array.isArray(offerCodes) ? offerCodes.length : 0
                    }
                  />
                  <Input
                    type="text"
                    label=""
                    placeholder="Enter website URL"
                    width="100%"
                    radius="5px"
                    InputDivClass="w-[100%] mt-5"
                    name="websiteURL"
                    value={websiteURL}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    error={errors.websiteURL}
                    touched={touched.websiteURL}
                  />
                </div>
              </div>
            ) : (
              <Input
                type="text"
                label=""
                placeholder="Enter website URL"
                width="100%"
                radius="5px"
                InputDivClass="w-[100%] mt-5"
                name="websiteURL"
                value={websiteURL}
                handleChange={handleChange}
                handleBlur={handleBlur}
                error={errors.websiteURL}
                touched={touched.websiteURL}
              />
            )}
          </>
        )}

        {/* 6. Offer Discount Type */}
        <Selector
          value={offerDiscountType}
          name="offerDiscountType"
          label={"Offer Discount Type"}
          labelClassName="lg:text-[14px] sm:text-[12px] font-[500] text-[#303030] font-poppins leading-[21px] mb-[4px]"
          divClassName="mt-8 w-[100%]"
          selectClassName="w-full rounded-[5px] bg-[#FFFFFF] text-[#303030] lg:text-[16px] sm:text-[10px] font-[400] !font-poppins !focus:outline-none"
          flexClassName="gap-3"
          options={offerDiscountTypeOptions}
          suffixIcon={<DownArrow />}
          placeholder={"Select Offer Discount Type"}
          onChange={handleDiscountTypeChange}
          handleBlur={handleBlur}
          error={errors.offerDiscountType}
          touched={touched.offerDiscountType}
        />

        {/* Conditional fields for Offer Discount Type */}
        {offerDiscountType === "DISCOUNTED_PERCENT" && (
          <div className={`mt-8 offerForm w-full ${isSliderDragging ? 'slider-dragging' : ''}`}>
            <p className="invitationLabels lg:text-[14px] sm:text-[12px] font-[500] text-[#303030] font-poppins leading-[21px] mb-[4px]">Discount Range</p>
            <Slider
              className="mt-4 w-full single-handle-slider"
              min={0}
              max={100}
              step={1}
              disabled={false}
              onChange={handleRangeChange}
              onAfterChange={handleRangeAfterChange}
              value={rangeValue}
              name="discountRange"
              onBlur={handleBlur}
              tooltipVisible={false}
            />
          </div>
        )}

        {offerDiscountType === "FIXED_DOLLAR" && (
          <Input
            type="number"
            label="Fixed Dollar Amount"
            placeholder="Add Amount"
            width="100%"
            radius="5px"
            InputDivClass="w-[100%] mt-8"
            name="fixedDollarAmount"
            value={fixedDollarAmount}
            handleChange={handleChange}
            handleBlur={handleBlur}
            error={errors.fixedDollarAmount}
            touched={touched.fixedDollarAmount}
          />
        )}

        {/* {showModal && (
          <CancelPopup
            handleNo={closeModal}
            handleYes={handleShowImageUploader}
            heading={modalContent}
            content={`Do you want to upload a ${modalContent} image?`}
            // image={deleteImg}
            confirmation={true}
          />
        )}
        {uploadOption === "upload" && redemedOffer !== "Alphanumeric Code" && (
          <p className="font-poppins font-[400] sm:text-[10px] md:text-[12px] text-[#767676] mt-6">
            {`Great! Please proceed to upload your ${modalContent} image now.`}
          </p>
        )}

        {uploadOption === "auto-generate" &&
          redemedOffer !== "Alphanumeric Code" && (
            <p className="font-poppins font-[400] sm:text-[10px] md:text-[12px] text-[#767676] mt-6">
              {`No worries! We will automatically generate a 
           ${modalContent} for
            you.`}
            </p>
          )}

        {showUploadDocument && (
          <UploadDocument
            thumbnail={redemptionMethod}
            name={"redemptionMethod"}
            iconText={`Upload ${modalContent}`}
            error={errors?.redemptionMethod}
            touched={touched?.redemptionMethod}
            setFieldValue={setFieldValue}
            parentDivClass={"h-[406px] w-[100%] mt-8"}
            setFileUrl={setRedemptionMethodUrl}
            logoFileImage={redemptionMethodlogoFileImage}
            setLogoFileImage={setRedemptionMethodlogoFileImage}
          />
        )} */}

        <div className="w-full text-end mt-20">
          <GreyButton
            className="w-[40%] lg:w-[25%] h-[45px] rounded-[5px] text-[16px] font-[500] font-montserrat"
            label="Previous"
            onClick={handlePrevious}
          />
          <PrimaryButton
            className={
              "w-[40%] lg:w-[25%] h-[45px] rounded-[5px] text-[16px] font-[500] font-montserrat ms-2"
            }
            label={nextButtonLabel}
            disabled={
              isNextButtonBusy ||
              !title ||
              !offerType ||
              !offerDiscountType ||
              !thumbnailImage ||
              !Array.isArray(previewImages) || previewImages.length < 1 ||
              (offerType === "ONLINE_OFFER" && !websiteURL) ||
              (offerType === "ONLINE_OFFER" && onlineOption === "ONLINE_WITH_CODE" && (Array.isArray(offerCodes) ? offerCodes.length === 0 : !offerCodes))
            }
            onClick={async () => {
              const validationErrors = await formik.validateForm();
              if (!formik.values.offerType) {
                formik.setTouched({ ...formik.touched, offerType: true });
                formik.setFieldError("offerType", "Offer Type Selection is required");
              }
              if (Object.keys(validationErrors || {}).length > 0 || !formik.values.offerType) {
                formik.setTouched(
                  Object.keys(validationErrors).reduce((acc, k) => {
                    acc[k] = true;
                    return acc;
                  }, {}),
                  true
                );
                scrollToFirstError({ ...validationErrors, ...(formik.values.offerType ? {} : { offerType: "Offer Type Selection is required" }) });
                return;
              }
              console.log("Next button clicked");
              console.log("Form is valid:", formik.isValid);
              console.log("Form errors:", formik.errors);

              // Call createOffer directly to save offer codes to Redux store
              const processedCodes = processOfferCodes();
              console.log("Processed codes for direct save:", processedCodes);

              const currentPayload = {
                id: offerData?._id,
                merchantId: selectedMerchant?._id,
                title: title,
                offerType: offerType,
                offerDiscountType: offerDiscountType,
                onlineOption: onlineOption,
                discountRange: discountRange,
                fixedDollarAmount: fixedDollarAmount,
                offerCodes: processedCodes,
                thumbnailImage: thumbnailImage,
                previewImages: previewImagesUrl,
                description: description,
                websiteURL: websiteURL,
                isCreated: false,
              };

              console.log("Direct save payload:", currentPayload);

              try {
                const createPromise = await dispatch(
                  createOffer({ ...currentPayload, offerId: offerData?._id })
                )?.unwrap();

                if (createPromise?.success === true) {
                  console.log("Direct save successful, moving to next step");
                  setStepIndex(stepIndex + 1);
                } else {
                  console.log("Direct save failed:", createPromise);
                }
              } catch (error) {
                console.error("Direct save error:", error);
              }
            }}
          />
        </div>
      </div>
    </div >
  );
};

export default OfferCreation;
